import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "popup-wrapper" }
const _hoisted_2 = { class: "popup-text" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "question-icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "colored-end" }, null, -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "popup-slot-text" }
const _hoisted_10 = {
  key: 1,
  class: "scrim"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "popup-container",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showStickyNote = true))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "popup-title",
            innerHTML: $props.popupTitle
          }, null, 8, _hoisted_3),
          ($props.subheader)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "popup-subheader",
                innerHTML: $props.subheader
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", { src: $setup.helpImg }, null, 8, _hoisted_6)
        ]),
        _hoisted_7
      ])
    ]),
    ($setup.showStickyNote)
      ? (_openBlock(), _createBlock($setup["StickyNotePopup"], {
          key: 0,
          class: "sticky-note",
          "popup-title": $props.popupTitle,
          onClose: $setup.closeStickyNote
        }, _createSlots({
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _: 2
        }, [
          ($props.subheader)
            ? {
                name: "subheader",
                fn: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "popup-subheader-text",
                    innerHTML: $props.subheader
                  }, null, 8, _hoisted_8)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["popup-title"]))
      : _createCommentVNode("", true),
    ($setup.showStickyNote)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10))
      : _createCommentVNode("", true)
  ], 64))
}